import { Component } from '@theme/component';

/**
 * @typedef {object} PalprintzCompareRefs
 * @property {HTMLInputElement} range - Native range input that controls the divider.
 */

/**
 * Before/after image comparison. A visually transparent native range input sits over the
 * images, so pointer, touch, and keyboard all work without custom gesture handling; this
 * component only mirrors its value into a CSS custom property.
 *
 * @extends {Component<PalprintzCompareRefs>}
 */
class PalprintzCompare extends Component {
  requiredRefs = ['range'];

  connectedCallback() {
    super.connectedCallback();
    this.#update();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#update();
  }

  /**
   * Handles input on the range control.
   */
  handleInput() {
    this.#update();
  }

  /**
   * A range thumb's center travels from half a thumb width in from each edge, so the
   * divider follows the same track to stay under the (invisible) thumb.
   */
  #update() {
    const ratio = Number(this.refs.range.value) / 100;
    this.style.setProperty('--pp-compare', `calc(28px + (100% - 56px) * ${ratio})`);
  }
}

if (!customElements.get('palprintz-compare')) {
  customElements.define('palprintz-compare', PalprintzCompare);
}
